<template>
  <div class="title-box">
    <h2 class="title-box_title">Art by {{ artist.name }}</h2>
    <div class="title-box_right">
      <div class="title-box_right-content">
        <PublicSelect
          :items="sortData"
          :selected="cardData.sort"
          @input="$emit('selectSort', $event)"
        ></PublicSelect>
        <FilterBlock
          style="margin-left: 15px"
          :items="filters"
          :search="search"
          @open="$emit('update:openFilters', $event)"
          @selectFilter="$emit('selectFilter', $event)"
          @apply="$emit('applyFilters')"
          @clear="$emit('clearFilters')"
          @changeSearch="$emit('changeSearch', $event)"
        ></FilterBlock>
      </div>
    </div>
  </div>
</template>

<script>
import PublicSelect from "@/components/inputs/PublicSelect.vue";
import FilterBlock from "@/components/FilterPublic.vue";

export default {
  components: {
    PublicSelect,
    FilterBlock,
  },
  props: {
    artist: Object,
    sortData: Array,
    cardData: Object,
    filters: Array,
    search: String,
    openFilters: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.title-box {
  @include titleFlexWrapper;
  &_right {
    @include rightActionsWrapper();
  }
  &_title {
    font-size: 4rem;
    line-height: 5rem;
    @media screen and (max-width: $xs) {
      font-size: 3.5rem;
      line-height: 4.3rem;
    }
  }
}
</style>

